import React, { useState } from "react";

// region External libraries
import { ClickAwayListener, IconButton, Tooltip } from "@libraries/mui/components";
import { HelpOutline } from "@libraries/mui/icons";
// endregion External libraries

import * as Styled from "./styles";

interface IHelpTipProps {
  /** The explanation; screen readers also read it on the button. */
  text: string;
}

/**
 * A "?" next to something that needs explaining. It opens on hover like any
 * tooltip, and also on a click — which stays open until the next click or a
 * click elsewhere — so the operator finds the explanation without guessing
 * that a word can be hovered, on a touch screen too.
 */
const HelpTip: React.FC<IHelpTipProps> = ({ text }) => {

  // region States
  const [pinned, setPinned] = useState<boolean>(false);
  const [hovered, setHovered] = useState<boolean>(false);
  // endregion States

  return (
    <ClickAwayListener onClickAway={() => setPinned(false)}>
      <Styled.HelpTipAnchor>
        <Tooltip
          arrow
          placement="top"
          title={<Styled.HelpTipText>{text}</Styled.HelpTipText>}
          open={pinned || hovered}
          onOpen={() => setHovered(true)}
          onClose={() => setHovered(false)}
          enterTouchDelay={0}
        >
          <IconButton
            size="small"
            aria-label={text}
            aria-expanded={pinned}
            onClick={(event) => {
              // Inside a clickable row or label, the "?" only explains.
              event.preventDefault();
              event.stopPropagation();
              setPinned((current) => !current);
            }}
          >
            <HelpOutline fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </Styled.HelpTipAnchor>
    </ClickAwayListener>
  );
};

export default HelpTip;
